const addGa4Event = (data)=>{
    const { event , event_type , event_detail  } = data;
    const dataLayer = window.dataLayer || [];
    if (dataLayer && dataLayer.push) {
        dataLayer.push({
            event,
            event_type,
            event_detail
        });
    }
};
export default addGa4Event;

//# sourceMappingURL=ga4Event.js.map